const SESSION_ID_KEY = 'cnfdSessionId';

export const getSessionId = (): string => {
  let id = sessionStorage.getItem(SESSION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_ID_KEY, id);
  }
  return id;
};
